module.exports = "../../app/cells/pages/contest/summary/show.erb";